import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0968603c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-wrap" }
const _hoisted_2 = { class: "p-mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.formDef.label), 1),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}